import React from "react";

export const notificationContext = React.createContext();

export const NotificationState = ({ children }) => {
  return (
    <notificationContext.Provider
      value={React.useState({ visible: false, message: "" })}
    >
      {children}
    </notificationContext.Provider>
  );
};
